import { useCallback, useEffect, useState } from "react";

export function useExcludeStatus(
  navigate: (opts: {
    search: (prev: Record<string, unknown>) => Record<string, unknown>;
    replace: boolean;
  }) => void,
  excludeStatus: string | undefined,
) {
  const [isExcludeStatusCleared, setIsExcludeStatusCleared] = useState(false);

  useEffect(() => {
    if (excludeStatus === undefined && !isExcludeStatusCleared) {
      navigate({
        search: (prev) => ({ ...prev, exclude_status: "cancelled" }),
        replace: true,
      });
    }
  }, [navigate, excludeStatus, isExcludeStatusCleared]);

  const excludeStatusValue = isExcludeStatusCleared
    ? excludeStatus || ""
    : (excludeStatus ?? "cancelled");

  const clearExcludeStatus = useCallback(
    () => setIsExcludeStatusCleared(true),
    [],
  );
  const resetExcludeStatus = useCallback(
    () => setIsExcludeStatusCleared(false),
    [],
  );

  return {
    excludeStatusValue,
    clearExcludeStatus,
    resetExcludeStatus,
    isExcludeStatusCleared,
  };
}
